import getApiClient from 'src/lib/getApiClient';
import apiRoutes from 'src/modules/DocumentsPrivate/constants/apiRoutes';
import { DOCUMENT_API_URL } from 'src/modules/DocumentsPrivate/constants/api';
import {
  AgreementAcceptRequestType,
  AgreementSignatureResponse
} from 'src/modules/DocumentsPrivate/types';

const postAgreementAccept = async (
  request: AgreementAcceptRequestType
): Promise<AgreementSignatureResponse> => {
  const apiClient = getApiClient(DOCUMENT_API_URL);

  const { data: response } = await apiClient.post<AgreementSignatureResponse>(
    apiRoutes.agreementAccept,
    request
  );

  return response;
};

export default postAgreementAccept;
